import api from '../../fetch/api'
import * as types from '../types'

const state = {
  cityList: ''
}

const actions = {
  getCityList ({commit}, param) {
    commit(types.COM_LOADING, true)
    api.getGroup(`mapgroupdata?${param}`).then(res => {
      commit(types.COM_LOADING, false)
      commit(types.CITY_LIST, res)
    })
  }
}

const getters = {
  getCityList: state => state.cityList
}

const mutations = {
  [types.CITY_LIST] (state, res) {
    state.cityList = res
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/module/city.js